import { render, staticRenderFns } from "./TrusteeToTrusteeTransferDetails.vue?vue&type=template&id=257e0da2"
import script from "./TrusteeToTrusteeTransferDetails.vue?vue&type=script&lang=ts"
export * from "./TrusteeToTrusteeTransferDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports